module.exports = __webpack_public_path__ + "img/tb-logo-black.a899572f.png";